"use strict";

var _toConsumableArray = require("D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");
exports.__esModule = true;
exports.useActiveDescendant = exports.setActiveDescendant = void 0;
var _react = require("react");

/**
 * Do a "hard" set on the aria, so that it's always announced
 * even if the id hasn't changed, this saves us from having to have a different id
 * per item.
 */
var setActiveDescendant = function setActiveDescendant(ref, activeId) {
  if (!ref) return;
  ref.removeAttribute('aria-activedescendant');
  if (activeId) ref.setAttribute('aria-activedescendant', activeId);
};
exports.setActiveDescendant = setActiveDescendant;
var useActiveDescendant = function useActiveDescendant(ref, id, visible, deps) {
  (0, _react.useEffect)(function () {
    setActiveDescendant(ref.current, visible ? id : ''); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, id, visible].concat(_toConsumableArray(deps)));
};
exports.useActiveDescendant = useActiveDescendant;